module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns-house_access_04-e6337084a658e92d8b3bd7fb274681d9.jpg";